import type { TxComponent } from '@landfolk/styling/types/landstyle'
import type { ReactNode } from 'react'

export type BadgeProps = {
  type?:
    | 'default'
    | 'alert'
    | 'error'
    | 'success'
    | 'warning'
    | 'muted'
    | 'dark'
    | 'info'
    | 'fall'
  height?: string
  children: ReactNode
} & TxComponent

export function Badge({
  type = 'default',
  height,
  children,
  className,
  style,
  ...rest
}: BadgeProps) {
  return (
    <span
      tx={[
        tx`inline-block whitespace-nowrap rounded px-2 py-1 font-sans text-f8 font-bold uppercase`,
        getBadgeStyleForType(type),
        !height && tx`h-[1.5rem]`,
      ]}
      style={{
        height,
        ...style,
      }}
      className={className}
      {...rest}
    >
      {children}
    </span>
  )
}

export function getBadgeStyleForType(type: BadgeProps['type']) {
  switch (type) {
    case 'muted':
      return tx`bg-neutral-200 text-february-muted`
    case 'success':
      return tx`bg-confirmation text-white`
    case 'warning':
      return tx`bg-beach-700 text-white`
    case 'error':
      return tx`bg-error text-white`
    case 'alert':
      return tx`bg-forest-800 text-beach-100`
    case 'dark':
      return tx`bg-february bg-opacity-60 text-white`
    case 'info':
      return tx`bg-info text-info-muted`
    default:
      return tx`bg-beach-300 text-february`
  }
}
